<template>
  <div class="long-video" ref="longVideo">
    <md-scroll-view
      ref="scrollView"
      :scrolling-x="false"
      :auto-reflow="true"
      :end-reached-threshold="100"
      :immediate-check-end-reaching="true"
      @end-reached="onEndReached"
    >
      <!-- 跑马灯 -->
      <div class="noticeBox">
        <div class="notice">
          <div class="noticeLeft">
            <img alt="喇叭" :src="require('./assets/speakerNew.png')">
          </div>
          <div class="noticeRight" :style="{ '--animation': animation }">
              <md-notice-bar scrollable>
                {{ noticeList }}
              </md-notice-bar>
          </div>
        </div>
      </div>
      <!-- banner -->
      <md-swiper
          v-if="bannerList.length"
          ref="swiper"
          :is-prevent="false"
          :useNative-driver="false"
          class="swiper1"
      >
        <md-swiper-item :key="item.id" v-for="item in bannerList">
          <img v-lazy="item.h5_pic" @click="goLink(item)" />
        </md-swiper-item>
      </md-swiper>
      <!-- 热门推荐 -->
      <!-- <div class="title-wrapper">
        <div class="left">
          <i class="recommend"/>
          <span>
            <img :src="require('./assets/hot-recommend.png')" alt=""/>
          </span>
        </div>
        <div class="right" @click="changeVideos('recommend')">
          <span>{{ $t('homeLongChange') }}</span>
          <i :class="{ rotate: changType === 'recommend' }" />
        </div>
      </div> -->
       <!-- 热门推荐 -->
      <!-- <swiper class="swiper2" :options="swiperOption" :not-next-tick="true" ref="mySwiper">
        <swiper-slide ref="swiperSlide" :key="item.id" :id="item.id" v-for="item in recommendVideos" @touchstart.native="showFragment = item.id" @touchend.native="showFragment = null">
          <img v-lazy="item.pic" />
          <img v-if="showFragment === item.id && item.gif" v-lazy="item.gif" />
        </swiper-slide>
      </swiper> -->
      <div class="tabs">
        <div
            class="tab-item"
            v-for="(item, index) in tab"
            :key="index"
            :class="{ active: selectTypeKey === item.value }"
            @click="selectType(item)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="video-list">
      <!-- <md-scroll-view
          ref="scrollView"
          :scrolling-x="false"
          :auto-reflow="true"
          :end-reached-threshold="100"
          :immediate-check-end-reaching="true"
          @end-reached="onEndReached"
          class="outer-scrollView"
      > -->
        <!--下拉刷新组件-->
        <!-- <md-scroll-view-refresh
            slot="refresh"
            slot-scope="{ scrollTop, isRefreshActive, isRefreshing }"
            :scroll-top="scrollTop"
            :is-refreshing="isRefreshing"
            :is-refresh-active="isRefreshActive"
            :refreshText="$t('refreshText')"
            :refreshActiveText="$t('refreshActiveText')"
            :refreshingText="$t('refreshingText')"
        ></md-scroll-view-refresh> -->
        <div class="content">
          <VideoEntry v-for="(subItem, subIndex) in videos" :key="subIndex" :videoData="subItem" @doSetScrollPositionY="doSetScrollPositionY"/>
        </div>

        <no-data v-if="!videos.length" />

        <!--        上拉加载更多组件-->
        <md-scroll-view-more
            slot="more"
            :is-finished="isFinished"
            :loading-text="$t('loading')"
            :finished-text="videos.length ? $t('noMoreData') : ''"
        >
        </md-scroll-view-more>
      <!-- </md-scroll-view>  -->
      </div>
      <div class="h-30"></div>
    </md-scroll-view>
    <md-popup
        v-model="isShowSide"
        position="right"
        class="sideMenu"
    >
      <div class="label-wrapper">
        <div class="label-header">
          <i class="close" @click="closeSide" />
        </div>

        <md-scroll-view
            :scrolling-x="false"
            :auto-reflow="true"
        >
          <!--          标签-->
          <div class="label-list-wrapper">
            <div class="label"
                 v-for="(subItem, subIndex) in homeClass"
                 :key="subIndex + 'subIndex'"
                 :class="{'active' : subItem.id * 1 === selectClassKey * 1}"
                 @click="changeSelectKey(subItem)"
            >
              <span>#</span>
              <span>{{ subItem.name }}</span>
            </div>
          </div>
        </md-scroll-view>
      </div>
    </md-popup>
  </div>
</template>

<script>
import VideoEntry from '@components/VideoEntry';
// import Marquee from '@components/Marquee';
import { Swiper, SwiperItem, NoticeBar } from 'mand-mobile';
// import { getRecommend, getNotice, getAdvertise, getHomeClass, getHomeList } from '@api/longVideo';
import { getAdvertise, getRecommend, getHomeClass, getVideoList } from '@api/longVideo';
import NoData from '@/components/NoData/index';

export default {
  name: 'LongVideo',
  components: {
    [Swiper.name]: Swiper,
    [NoticeBar.name]: NoticeBar,
    [SwiperItem.name]: SwiperItem,
    NoData,
    VideoEntry
    // Marquee
  },
  props: {
    selectClassKey: {
      type: String,
      default: () => '0'
    },
    isShowPoup: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    const vm = this;
    return {
      isShowSide: false,
      page: 1,
      searchContent: '',
      orderType: 0,
      isAsc: 1,
      selectTypeKey: '0',
      showFragment: null,
      recommendVideos: [],
      pageSize: 6,
      // pageHot: 1,
      // pageNew: 1,
      pageRecommend: 1,
      // pageCountHot: 0,
      // pageCountNew: 0,
      pageCountRecommend: 0,
      swiperOption: {
        watchSlidesProgress: true,
        slidesPerView: 1,
        // centeredSlides: true,
        loop: true,
        loopedSlides: 1,
        autoplay: 2000,
        preventClicks: false,
        onClick (slide) {
          vm.doSetScrollPositionY();
          localStorage.setItem('fromRoute', vm.$route.fullPath);
          vm.$router.push({ path: '/videoDetail', query: { videoId: slide.clickedSlide.id } });
        }
      },
      getRecommendReq: false,
      changType: '',
      noticeList: '',
      bannerList: [],
      homeClass: [],
      videos: [],
      isFinished: false,
      currentSelectKey: '0',
      animation: '12s',
      scrollPositionYLocal: 0
    };
  },
  computed: {
    ...mapState('publicStore', ['scrollPositionY', 'marqueeText']),
    mySwiper () {
      return this.$refs.mySwiper.swiper;
    },
    tab () {
      return [
        {
          name: '推荐',
          value: '0'
        },
        {
          name: '最新',
          value: '1'
        },
        {
          name: '热门',
          value: '2'
        }
      ];
    },
    noticeLists () {
      console.log(this.marqueeText);
      const list = this.marqueeText.map(item => item.content).join('  ');
      this.$nextTick(() => {
        if (list * 0.18 > 10) {
          this.animation = `${list * 0.18}s`;
        }
      });
      return list;
    }
  },
  activated () {
    // 在首次挂载、
    // this.mySwiper.startAutoplay();
    setTimeout(() => {
      this.$refs.scrollView.scrollTo(0, this.scrollPositionYLocal);
      this.$refs.scrollView.finishLoadMore();
    }, 100);
    // 以及每次从缓存中被重新插入的时候调用
    // this.mySwiper.update();
  },
  created () {
    this.getRecommend();
    this.getHomeClass();
    // this.getHot();
    // this.getNoticeList();
    this.getBannerList();
    setTimeout(() => {
      this.noticeList = this.noticeLists;
    }, 100);
    //  绑定切换语言后要调用的接口
    // this.initAfterChangeLang([this.getRecommend, this.getNoticeList, this.getBannerList]);
  },
  watch: {
    selectClassKey (val) {
      this.isFinished = false;
      this.page = 1;
      this.videos = [];
      this.selectTypeKey = '0';
      this.isAsc = 1;
      this.orderType = 0;
      this.currentSelectKey = val;
      this.getVideoList();
    },
    isShowPoup (val) {
      this.isShowSide = val;
    },
    marqueeText: {
      handler (val) {
        // 根据返回的数组 提出content 组成字符串
        this.noticeList = val.map(item => item.content).join('  ');
        // this.noticeList = '推荐使用QT钱包福利多多首提首存彩金、连续充值彩金平台网址更新通知易记域名：8620.com易记域名：8620.vip新增域名：86202024.com86202024a.com86202024b.com86202024C.com86202024Y.com86202024Z.com86202024（26个字母都可以）.com 使用QT钱包福利多多下载网址：qtpay3.com教程网址：qtpayjc.com首存100+成功即送58元首提100+成功即送38元使用QTpay钱包连续充值7天即送58元彩金使用QTpay钱包连续充值15天即送88元彩金使用QTpay钱包连续充值30天即送188元彩金彩金联系QTpay在线客服领取 网页点击上方立即打开下载APP导航网址：8620.com易记网址：8620.vipAPP网址：app8620.com备用网址：8620ff.com移动网址：8620qq.com寰宇浏览器：ub66.com移动客户使用移动网址推荐下载寰宇浏览器截图保存可以防止走丢哦~专属礼包注册送彩金最高送58一重首存享好礼最高送3888元二重复存再加赠最高送1888元三重打码送豪礼最高送3888元四重首提再送钱最高反还88元每天22点APP免费红包反还10%';
        // const wrap = document.querySelector('.noticeRight');
        this.$nextTick(() => {
          if (this.noticeList.length * 0.18 > 10) {
            this.animation = `${this.noticeList.length * 0.18}s`;
          }
        });
      },
      deep: true
    }
  },
  methods: {
    ...mapActions('home', ['collect']),
    ...mapActions('publicStore', ['analysis']),
    ...mapMutations('publicStore', ['setScrollPositionY']),
    changeSelectKey (item) {
      this.currentSelectKey = item.id + '';
      this.isShowSide = false;
      this.isFinished = false;
      this.page = 1;
      this.videos = [];
      this.selectTypeKey = '0';
      this.isAsc = 1;
      this.orderType = 0;
      this.getVideoList();
      this.$emit('closePoup', this.currentSelectKey);
    },
    closeSide () {
      this.isShowSide = false;
      this.$emit('closePoup', this.currentSelectKey);
    },
    getRecommend () {
      if (this.getRecommendReq) return;
      const params = {
        page: this.pageRecommend,
        page_size: 3
      };
      this.getRecommendReq = true;
      getRecommend(params).then(res => {
        this.getRecommendReq = false;
        if (res.result === 200000) {
          this.recommendVideos = res.data.list.list;
          this.pageCountRecommend = res.data.list.pageCount;
        }
      }).catch(() => {
        this.getRecommendReq = false;
      });
    },
    getHomeClass () {
      getHomeClass().then(res => {
        if (res.result === 200000) {
          this.homeClass = res.data.list;
        }
      });
    },
    selectType (val) {
      this.selectTypeKey = val.value;
      if (val.value === '0') {
        this.orderType = 0;
        this.isAsc = 1;
      } else if (val.value === '1') {
        this.orderType = 0;
        this.isAsc = 0;
      } else if (val.value === '2') {
        this.orderType = 1;
        this.isAsc = 1;
      }
      this.page = 1;
      this.videos = [];
      this.getVideoList();
    },
    getVideoList () {
      if (this.currentSelectKey * 1 === 0) return;
      const params = {
        page: this.page,
        page_size: this.pageSize,
        title: this.searchContent,
        order_type: this.orderType,
        is_asc: this.isAsc,
        class: this.currentSelectKey
      };
      getVideoList(params).then(res => {
        if (res.result === 200000) {
          this.videos = this.videos.concat(res.data.list.list);
          this.pageCount = res.data.list.pageCount;
          this.page = res.data.list.page;
          this.totalPageCount = res.data.list.pageCount;
          if (this.page >= this.totalPageCount) {
            this.isFinished = true;
          }
          this.$refs.scrollView.finishLoadMore();
        }
      }).catch(() => {
        // this.getHomeListReq = false;
      });
    },
    changeVideos (item) {
      if (item === 'recommend') {
        this.changType = item;
        setTimeout(() => {
          this.changType = '';
        }, 500);
        if (this.pageRecommend < this.pageCountRecommend) {
          this.pageRecommend++;
        } else {
          this.pageRecommend = 1;
        }
        this.getRecommend();
        return;
      }

      this.changType = item.id;
      setTimeout(() => {
        this.changType = '';
      }, 500);
      if (item.page < item.pageCount) {
        item.page++;
      } else {
        item.page = 1;
      }
      this.getVideoList();
    },
    doCollect (item) {
      this.collect(item);
    },
    /*    getNoticeList () {
      // 1跑马灯 2公告
      getNotice({ type: 1 }).then(res => {
        if (res.result === 200000) {
          // 根据返回的数组 提出content 组成字符串
          this.noticeList = res.data.list.map(item => item.content).join(' ');
          // this.noticeList = '推荐使用QT钱包福利多多首提首存彩金、连续充值彩金平台网址更新通知易记域名：8620.com易记域名：8620.vip新增域名：86202024.com86202024a.com86202024b.com86202024C.com86202024Y.com86202024Z.com86202024（26个字母都可以）.com 使用QT钱包福利多多下载网址：qtpay3.com教程网址：qtpayjc.com首存100+成功即送58元首提100+成功即送38元使用QTpay钱包连续充值7天即送58元彩金使用QTpay钱包连续充值15天即送88元彩金使用QTpay钱包连续充值30天即送188元彩金彩金联系QTpay在线客服领取 网页点击上方立即打开下载APP导航网址：8620.com易记网址：8620.vipAPP网址：app8620.com备用网址：8620ff.com移动网址：8620qq.com寰宇浏览器：ub66.com移动客户使用移动网址推荐下载寰宇浏览器截图保存可以防止走丢哦~专属礼包注册送彩金最高送58一重首存享好礼最高送3888元二重复存再加赠最高送1888元三重打码送豪礼最高送3888元四重首提再送钱最高反还88元每天22点APP免费红包反还10%';
          // const wrap = document.querySelector('.noticeRight');
          this.$nextTick(() => {
            if (this.noticeList.length * 0.18 > 10) {
              this.animation = `${this.noticeList.length * 0.18}s`;
            }
          });
        }
      }).catch(() => {
      });
    }, */
    getBannerList () {
      // 1 banner 2 海报
      getAdvertise({ type: 1 }).then(res => {
        if (res.result === 200000) {
          this.bannerList = res.data.list;
        }
      }).catch(() => {
      });
    },
    goLink (item) {
      this.analysis({ id: item.id, type: 1 });
      // window.open(item.link);
      this.jumpPath({ url: item.link });
    },
    doSetScrollPositionY () {
      // console.log('scrollView1');
      this.scrollPositionYLocal = this.$refs.scrollView.getOffsets().top;
      this.setScrollPositionY(this.$refs.scrollView.getOffsets().top);
    },
    onRefresh () {
      if (this.currentSelectKey * 1) {
        this.videos = [];
        this.page = 1;
        this.getVideoList();
      }
    },
    onEndReached () {
      if (this.isFinished) return;
      this.page += 1;
      this.getVideoList();
    }
  }
};
</script>

<style lang="scss" scoped>
.h-30 {
  height: 30px;
}
.long-video {
  height: 100%;
  //padding-top: 60px;

  .md-scroll-view {
    height: calc(100% - 80px);
  }

  .swiper1 {
    height: 174px;
    width: 345px;
    margin: 0 auto;
    margin-top: 10px;
    // margin-bottom: 10px;
    /deep/ .md-swiper-item {
      height: 174px!important;
      border-radius: 4px;
      img {
        width: 100%;
        //height: 100%;
      }
    }
    /deep/ .md-swiper-indicators {
      bottom: 10px;
      .md-swiper-indicator {
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background: #FFFFFF99;
      }
      .md-swiper-indicator.md-swiper-indicator-active {
        width: 12px;
        height: 5px;
        border-radius: 9px;
        background: #FFFFFF;
      }
    }
  }

  .noticeBox {
    width: 100%;
    height: 34px;
    padding: 0 10px;
    .notice {
      width: 100%;
      height: 100%;
      background: #363636;
      display: flex;
      align-items: center;
      overflow: hidden;
      border-radius: 8px;
      .noticeLeft {
          width: 30px;
          height: 22px;
          display: flex;
          padding-left: 3px;
          overflow: hidden;
          img {
            width: 22px;
            height: 22px
          }
      }
      .noticeRight {
        flex: 1;
        overflow: hidden;
        background: #363636;
        /deep/.md-notice-bar {
          padding-left: 0;
          font-size: 15px;
          color: #fff;
          background: #363636;
          font-family: PingFangSC-Regular;
          .md-notice-bar-right {
            padding-right: 5px;
          }
          .md-notice-bar-content .md-notice-bar-content-animate {
              padding-left: 100%;
              display: inline-block;
              animation: md-notice-bar-animation linear infinite both;
              animation-duration: var(--animation);
          }
        }
      }
    }
  }

  .swiper2 {
    width: 345px;
    /deep/ .swiper-slide {
      width: 345px;
      height: 158px!important;
      background: rgba(0, 0, 0, 0.2);
      border-radius: 4px;
      overflow: hidden;
      margin: 0 auto;
      img {
        position: absolute;
        width: 345px;
        border-radius: 4px;
        //height: 100%;
      }

      .play {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 40px;
        height: 40px;
        background: url("~@assets/imgs/public/playIcon.png") 0 0/100% 100%;
      }

      .vip {
        position: absolute;
        right: 0;
        top: 0;
        width: 33px;
        height: 17px;
        background: url("~@assets/imgs/public/vipIcon.png") 0 0/100% 100%;
      }

      .collect {
        position: absolute;
        left: 10px;
        top: 12px;
        width: 30px;
        height: 30px;
        background-image: url("./assets/collectDefault.png");
        background-size: 16px 16px;
        background-position: center;
        background-repeat: no-repeat;

        &.active {
          background-image: url("./assets/collectActive.png");
        }
      }

      .down-area {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 75px;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.7) 100%);
        border-radius: 6px;

        .title {
          position: absolute;
          left: 8px;
          bottom: 12px;
          width: 150px;
          font-family: 'PingFang SC';
          font-weight: 500;
          font-size: 12px;
          color: #FFF;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .time {
          position: absolute;
          right: 12px;
          bottom: 8px;
          height: 19px;
          padding: 0 5px;
          background: url("~@assets/imgs/public/timeBg.png") 0 0/100% 100%;
          font-family: 'PingFang HK';
          font-size: 12px;
          line-height: 19px;
          color: #FFF;
        }
      }
    }
  }

  .title-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    margin-top: 12px;
    padding: 0 10px;

    .left {
      display: flex;
      align-items: center;

      i {
        width: 6px;
        height: 20px;
        margin-right: 4px;
        background-size: 100% 100%;

        &.recommend {
          background-image: url("assets/recommendNew.png");
        }

        //&.new {
        //  background-image: url("assets/new.png");
        //}
        //
        //&.hot {
        //  background-image: url("assets/hot.png");
        //}
      }

      span {
        img {
          width: 95px;
          height: 22px;
        }
      }
    }

    .right {
      display: flex;
      align-items: center;

      span {
        font-family: 'PingFang SC';
        font-weight: 400;
        font-size: 13px;
        line-height: 12px;
        color: rgba(255, 255, 255, 0.7);
      }

      i {
        width: 16px;
        height: 16px;
        margin-left: 4px;
        background-size: 100% 100%;
        background-image: url("assets/freshIcon.png");

        &.rotate {
          animation: rotate 0.5s ease-in-out infinite;
        }

        @keyframes rotate
        {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
      }
    }
  }

  .content {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 0 10px;
    // margin-bottom: 80px;

    .video-entry {
      margin-bottom: 14px;
    }
  }
  .tabs {
    display: flex;
    gap: 10px;
    margin:21px 10px;
    align-items: center;
    .tab-item {
      font-family: 'PingFang SC';
      font-weight: 400;
      font-size: 15px;
      color: #fff;
      opacity: 0.7;
      cursor: pointer;
      &.active {
        color: #fff;
        font-size: 18px;
        opacity: 1;
        &::after {
          content: '';
          display: block;
          width: 100%;
          height: 2px;
          background: #E7992A;
          border-radius: 2px;
          margin-top: 4px;
        }
      }
    }
  }
  .video-list {
    height: calc(100% - 80px);
  }
}
.label-wrapper {
  width: 306px;
  height: 100%;
  padding: 24px 0 0 16px;
  background: #1C1E23;
  .label-header {
    margin-bottom: 19px;
    i {
      width: 24px;
      height: 24px;
      background: url("./assets/closeIcon.png") 0 0/100% 100%;
    }
  }
  .md-scroll-view {
    height: calc(100% - 50px);
  }
  .label-list-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 20px;
  .label {
    width: 50%;
    margin-bottom: 12px;
    span {
      font-family: 'PingFang SC';
      font-weight: 400;
      font-size: 13px;
      line-height: 13px;
      color: rgba(255, 255, 255, 0.8);
      &:first-of-type {
        margin-right: 3.5px;
        color: #32B8AF;
      }
    }
    &.active {
      span {
        font-size: 18px;
        color: #fff;
        &:first-of-type {
          margin-right: 3.5px;
          color: #32B8AF;
        }
      }
    }
  }
}
}
@-moz-keyframes md-notice-bar-animation {
    0% {
        transform: translateZ(0)
    }

    to {
        transform: translate3d(-100%,0,0)
    }
}

@-webkit-keyframes md-notice-bar-animation {
    0% {
        transform: translateZ(0)
    }

    to {
        transform: translate3d(-100%,0,0)
    }
}

@-o-keyframes md-notice-bar-animation {
    0% {
        transform: translateZ(0)
    }

    to {
        transform: translate3d(-100%,0,0)
    }
}

@keyframes md-notice-bar-animation {
    0% {
        transform: translateZ(0)
    }

    to {
        transform: translate3d(-100%,0,0)
    }
}
</style>
